import styled from 'styled-components';

export const KlarnaPdpWidgetContainer = styled.div`
  #klarna-pdp-widget::part(osm-container) {
    background-color: transparent;
    border: none;
    margin-bottom: 16px;
    margin-top: 16px;
    padding: 0;
  }
  #klarna-pdp-widget::part(osm-message),
  #klarna-pdp-widget::part(osm-cta) {
    font-family: 'Montserrat', sans-serif;
    font-size: 16px;
    line-height: 28px;
  }
  #klarna-pdp-widget::part(osm-legal) {
    display: unset;
    font-size: 12px;
  }
`;
